module.exports = __webpack_public_path__ + "img/logo-shopeepay_qris-inactive.0f456dfe.svg";